import React from 'react'

function Footer() {
  return (

    <div class="footer-position mt-48 pb-0">
    <div class="footer-background flex ">
       <div class="order-1 basis-1/2"> 

       <img src=""/>
       </div>
        <div class="order-2 basis-1/2 text-white p-16 pl-32">
            <div class="footer-connect">CONNECT</div>
            <div class="mt-2 font-extralight tracking-wide">
             +91-8076668991 
             </div>
             <div class="mt-2 font-extralight tracking-wide">
             ritikamishra112@gmail.com
             </div>
             </div>
             </div>
    </div>
  )
}

export default Footer